import Vue from "vue";
import axios from "axios";
import store from '@/store';
import VueRouter from "vue-router";
import Vue2Editor from "vue2-editor";
import Login from "@/components/Login.vue";
// import Dashboard from "@/components/Dashboard.vue";

const Roles = () => import("@/views/roles/roles.vue");
const Users = () => import("@/views/Users/User.vue");
// const Abogados = () => import("@/views/Users/abogados.vue");
const UpdatePassword = () => import("@/components/UpdatePassword");
const RecuperaPassword = () => import("@/components/RecuperaPassword");
const Logs = () => import("@/views/logs/log.vue");
// const Home = () => import("../views/Home.vue");
// const ShowApelacion = () => import("@/views/Apelaciones/show.vue");
// const Tocas = () => import("@/views/Cuentas/Tocas.vue");
// const Bandeja = () => import("@/views/Cuentas/Bandeja.vue");


// const Efirma = () => import("@/views/Ordenes/eFirma.vue");
// const Contestacion = () => import("@/views/Apelaciones/contestacion.vue");
const NotFound = () => import("@/views/NotFound.vue");
// const Verificar = () => import("@/views/Verificar.vue");
// const ApelacionesFirma = () => import("@/views/Apelaciones/ApelacionesFirma.vue");
// const Firma = () => import("@/views/Apelaciones/Firmar.vue");
// const DocumentoFirma = () => import("@/views/Apelaciones/DocumentoFirma.vue");
// const Multifirma = () => import("@/views/Apelaciones/Multifirma.vue");
// const DocumentoCreate = () => import("@/views/Apelaciones/DocumentoCreate.vue");
// const Comunicados = () => import("@/views/Apelaciones/Comunicados.vue");
// const ComunicadoCreate = () => import("@/views/Apelaciones/ComunicadoCreate.vue");
// const ComunicadosList = () => import("@/views/Apelaciones/ComunicadosList.vue");
// const ContestacionMultifirma = () => import("@/views/Apelaciones/contestacionMultifirma.vue");
// const ReporteMagistrado = () => import("@/views/Apelaciones/reporteMagistrado.vue");
// const ReporteApelaciones = () => import("@/views/Apelaciones/reporteApelaciones.vue");
// const Estadistica = () => import("@/views/Apelaciones/estadistica.vue");
// const Sentencia = () => import("@/views/Sentencias/SentenciasCreate.vue");
// const Amparo = () => import("@/views/Amparos/AmparosCreate.vue");
// const EscritosPanel = () => import("@/views/Ordenes/SentenciasPanel.vue");
// const AddObservacion = () => import("@/views/Cuentas/AddObservacion.vue");
// const Categorias = () => import("@/views/catCategorias/Categorias.vue");
// const RegistrarCategoria = () => import("@/views/catCategorias/Registrar.vue");
// const UpdateCategoria = () => import("@/views/catCategorias/Update.vue");
// const TipoDocumentos = () => import("@/views/catTipoDocumentos/TipoDocumento.vue");
// const RegistrarTipoDocumento = () => import("@/views/catTipoDocumentos/Registrar.vue");
// const UpdateTipoDocumento = () => import("@/views/catTipoDocumentos/Update.vue");
// const RegistrarToca = () => import("@/views/SecAcuerdos/RegistrarToca.vue");
// const Acciones = () => import("@/views/catAcciones/Acciones.vue");
// const RegistrarAccion = () => import("@/views/catAcciones/Registrar.vue");
// const UpdateAccion = () => import("@/views/catAcciones/Update.vue");
// const Delitos = () => import("@/views/catDelitos/Delitos.vue");
// const RegistrarDelito = () => import("@/views/catDelitos/Registrar.vue");
// const UpdateDelito = () => import("@/views/catDelitos/Update.vue");
// const Vias = () => import("@/views/catVias/Vias.vue");
// const RegistrarVia = () => import("@/views/catVias/Registrar.vue");
// const UpdateVia = () => import("@/views/catVias/Update.vue");
// const Sentidos = () => import("@/views/catSentidos/Sentidos.vue");
// const RegistrarSentido = () => import("@/views/catSentidos/Registrar.vue");
// const UpdateSentido = () => import("@/views/catSentidos/Update.vue");

// const SecAcuerdosIndex = () => import("@/views/SecAcuerdos/Index.vue");
// const Oficialia = () => import("@/views/Oficialia/Oficialia.vue");
// const Returno = () => import("@/views/SecAcuerdos/Returno.vue");
// const Asignacion = () => import("@/views/Magistrado/Index.vue");

// const TipoApelacion = () => import("@/views/catTipoApelacion/TipoApelacion.vue");
// const RegistrarTipoApelacion = () => import("@/views/catTipoApelacion/Registrar.vue");
// const UpdateTipoApelacion = () => import("@/views/catTipoApelacion/Update.vue");
// const Municipios = () => import("@/views/catMunicipios/Municipios.vue");
// const RegistrarMunicipio = () => import("@/views/catMunicipios/Registrar.vue");
// const UpdateMunicipio = () => import("@/views/catMunicipios/Update.vue");
// const Juzgados = () => import("@/views/catJuzgados/Juzgados.vue");
// const RegistrarJuzgado = () => import("@/views/catJuzgados/Registrar.vue");
// const UpdateJuzgado = () => import("@/views/catJuzgados/Update.vue");
// const Tribunales = () => import("@/views/catTribunales/Tribunales.vue");
// const RegistrarTribunal = () => import("@/views/catTribunales/Registrar.vue");
// const UpdateTribunal = () => import("@/views/catTribunales/Update.vue");

// const ApelacionDetalles = () => import("@/views/Apelaciones/ApelacionDetalles.vue");

// const Detalles = () => import("@/views/Apelaciones/Detalles.vue");
// const CuentaDetalles = () => import("@/views/Cuentas/Detalles.vue");
// const CuentaCancelar = () => import("@/views/Cuentas/Cancelar.vue");
// const CuentaSinMateria = () => import("@/views/Cuentas/SinMateria.vue");
// const CuentaExcusar = () => import("@/views/Cuentas/ExcusarMagistrado.vue");
// const ExcusarToca = () => import("@/views/SecAcuerdos/Excusar.vue");
// const RegistrarAmparo = () => import("@/views/Amparos/RegistrarAmparo.vue");
// const Colegiada = () => import("@/views/Cuentas/Colegiada.vue");
// const MisDocumentos = () => import("@/views/SecAcuerdos/MisDocumentos.vue");
// const DocumentosPendientesDeFirmar = () => import("@/views/SecAcuerdos/DocumentosPendientesDeFirmar.vue"); // Tocas pendientes de generar evidencia.
// const PendientesFirma = () => import("@/views/Apelaciones/pendientesFirma.vue");
const TocasList = () => import("@/views/Tocas/List.vue");
const TocasShow = () => import("@/views/Tocas/Show.vue");
const TocasFirma = () => import("@/views/Tocas/Firma.vue");

Vue.use(VueRouter);
Vue.use(Vue2Editor);
/*ROLES
  1 =>  SUPER-ADMIN

  CHECAR QUE COICINDAN CON LOS ASIGNADOS EM EL BACKEND
*/
const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
    alias: "/login"
  },
  // {
  //   path: "/home",
  //   name: "Home",
  //   component: Home,
  //   alias: "/Home"
  // },
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   component: Dashboard,
  //   meta: { authorize: [1, 2, 3, 4] }
  // },
  {
    path: "/roles",
    name: "Roles",
    component: Roles,
    meta: { authorize: ['superadmin','admin'] }
  },
  {
    path: "/user/editPassword",
    name: "UpdatePassword",
    component: UpdatePassword,
    meta: { authorize: ['superadmin','admin','ciudadano'] }
  },

  {
    path: "/recuperar-pass*",
    name: "RecuperaPassword",
    component: RecuperaPassword,
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: { authorize: ['superadmin','admin'] }
  },
  {
    path: "/logs",
    name: "Logs",
    component: Logs,
    meta: { authorize: ['superadmin','admin'] }
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: UpdatePassword,
    meta: { authorize: ['superadmin','admin','ciudadano'] }
  },
  // {
  //    path: "/tocas",
  //    name: "Tocas",
  //    component: Tocas,
  //    meta: { authorize: [1, 2, 3, 4, 5] }
  // },
  // {
  //   path: "/bandeja",
  //   name: "Bandeja",
  //   component: Bandeja,
  //   // meta: { authorize: [1, 2, 3, 5, 7, 8] }
  // },
  // {
  //   path: "/efirma",
  //   name: "Efirma",
  //   component: Efirma,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/firma",
  //   name: "Firma",
  //   component: Firma,
  //   meta: { authorize: [1, 2, 4] }
  // },
  // {
    // {
    //   path: "/documento/firma",
    //   name: "DocumentoFirma",
    //   component: DocumentoFirma,
    //   meta: { authorize: [1, 2, 3, 6] }
    // },
  // {
  //   path: "/reporte/magistrado",
  //   name: "ReporteMagistrado",
  //   component: ReporteMagistrado,
  //   meta: { authorize: [1, 6] }
  // },
  // {
  //   path: "/reporte/apelaciones",
  //   name: "ReporteApelaciones",
  //   component: ReporteApelaciones,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/estadistica",
  //   name: "Estadistica",
  //   component: Estadistica,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/multifirma",
  //   name: "Multifirma",
  //   component: Multifirma,
  //   meta: { authorize: [1] }
  //   // meta: { authorize: [1, 4] }
  // },
  // {
  //   path: "/documento/create",
  //   name: "DocumentoCreate",
  //   component: DocumentoCreate,
  //   meta: { authorize: [1, 2, 4, 6] }
  // },
  // {
  //   path: "/comunicado/create",
  //   name: "ComunicadoCreate",
  //   component: ComunicadoCreate,
  //   meta: { authorize: [1, 2, 4, 6] }
  // },
  // {
  //   path: "/comunicados",
  //   name: "Comunicados",
  //   component: Comunicados,
  //   meta: { authorize: [1, 2, 4, 6] }
  // },

  // {
  //   path: "/multifirma/contestacion",
  //   name: "ContestacionMultifirma",
  //   component: ContestacionMultifirma,
  //   meta: { authorize: [1] }
  //   // meta: { authorize: [1, 4] }
  // },
  // {
  //   path: "/contestacion",
  //   name: "Contestacion",
  //   component: Contestacion,
  //   meta: { authorize: [1, 2, 4, 7, 8] }
  // },
  {
    path :'*',
    component:NotFound
  },
  // {
  //   path :'/verificar*',
  //   name: "Verificar",
  //   component: Verificar,
  // },
  // {
  //   path: "/promociones/create",
  //   name: "Promociones",
  //   component: Promociones,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/apelaciones/firma",
  //   name: "ApelacionesFirma",
  //   component: ApelacionesFirma,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/escritos/panel",
  //   name: "EscritosPanel",
  //   component: EscritosPanel,
  //   meta: { authorize: [1, 2, 4, 6] }
  // },
  // {
  //   path: "/sentencias/create",
  //   name: "Sentencia",
  //   component: Sentencia,
  //   meta: { authorize: [1, 2] }
  //   // meta: { authorize: [1, 2, 4] }
  // },
  // {
  //   path: "/amparos/create",
  //   name: "Amparo",
  //   component: Amparo,
  //   meta: { authorize: [1, 2] }
  //   // meta: { authorize: [1, 2, 4] }
  // },
  // {
  //   path: "/cuentas/addobservacion",
  //   name: "AddObservacion",
  //   component: AddObservacion,
  //   // meta: { authorize: [1, 2, 4] }
  // },
  // {
  //   path: "/acciones",
  //   name: "Acciones",
  //   component: Acciones,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/acciones/registrar",
  //   name: "RegistrarAccion",
  //   component: RegistrarAccion,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/acciones/actualizar",
  //   name: "UpdateAccion",
  //   component: UpdateAccion,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/categorias",
  //   name: "Categorias",
  //   component: Categorias,
  //   meta: { authorize: [1, 2] }
  // },
  //   {
  //   path: "/categorias/registrar",
  //   name: "RegistrarCategoria",
  //   component: RegistrarCategoria,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/categorias/actualizar",
  //   name: "UpdateCategoria",
  //   component: UpdateCategoria,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tipo_documentos",
  //   name: "TipoDocumentos",
  //   component: TipoDocumentos,
  //   meta: { authorize: [1, 2] }
  // },
  //   {
  //   path: "/tipo_documento/registrar",
  //   name: "RegistrarTipoDocumento",
  //   component: RegistrarTipoDocumento,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tipo_documento/actualizar",
  //   name: "UpdateTipoDocumento",
  //   component: UpdateTipoDocumento,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/delitos",
  //   name: "Delitos",
  //   component: Delitos,
  //   meta: { authorize: [1, 2] }
  // },
  //   {
  //   path: "/delitos/registrar",
  //   name: "RegistrarDelito",
  //   component: RegistrarDelito,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/delitos/actualizar",
  //   name: "UpdateDelito",
  //   component: UpdateDelito,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/vias",
  //   name: "Vias",
  //   component: Vias,
  //   meta: { authorize: [1, 2] }
  // },
  //   {
  //   path: "/vias/registrar",
  //   name: "RegistrarVia",
  //   component: RegistrarVia,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/vias/actualizar",
  //   name: "UpdateVia",
  //   component: UpdateVia,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/sentidos",
  //   name: "Sentidos",
  //   component: Sentidos,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/sentidos/registrar",
  //   name: "RegistrarSentido",
  //   component: RegistrarSentido,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/sentidos/actualizar",
  //   name: "UpdateSentido",
  //   component: UpdateSentido,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tipo_apelacion",
  //   name: "TipoApelacion",
  //   component: TipoApelacion,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tipo_apelacion/registrar",
  //   name: "RegistrarTipoApelacion",
  //   component: RegistrarTipoApelacion,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tipo_apelacion/actualizar",
  //   name: "UpdateTipoApelacion",
  //   component: UpdateTipoApelacion,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/municipios",
  //   name: "Municipios",
  //   component: Municipios,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/municipios/registrar",
  //   name: "RegistrarMunicipio",
  //   component: RegistrarMunicipio,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/municipios/actualizar",
  //   name: "UpdateMunicipio",
  //   component: UpdateMunicipio,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/juzgados",
  //   name: "Juzgados",
  //   component: Juzgados,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/juzgados/registrar",
  //   name: "RegistrarJuzgado",
  //   component: RegistrarJuzgado,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/juzgados/actualizar",
  //   name: "UpdateJuzgado",
  //   component: UpdateJuzgado,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tribunales",
  //   name: "Tribunales",
  //   component: Tribunales,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tribunales/registrar",
  //   name: "RegistrarTribunal",
  //   component: RegistrarTribunal,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/tribunales/actualizar",
  //   name: "UpdateTribunal",
  //   component: UpdateTribunal,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/secacuerdos/tocas_add",
  //   name: "RegistrarToca",
  //   component: RegistrarToca,
  //   meta: { authorize: [1, 2] }
  // },
  // {
  //   path: "/secacuerdos",
  //   name: "SecAcuerdosIndex",
  //   component: SecAcuerdosIndex,
  //   meta: { authorize: [1, 2, 6] }
  // },
  // {
  //   path: "/secacuerdos/documetos",
  //   name: "MisDocumentos",
  //   component: MisDocumentos,
  //   meta: { authorize: [1, 2, 6] }
  // },
  // {
  //   path: "/documentos-pendientes-de-firmar",
  //   name: "DocumentosPendientesDeFirmar",
  //   component: DocumentosPendientesDeFirmar,
  //   meta: { authorize: [1, 2, 6] }
  // },
  // {
  //   path: "/oficialia",
  //   name: "Oficialia",
  //   component: Oficialia,
  //   meta: { authorize: [8] }
  // },
  // {
  //   path: "/returno",
  //   name: "Returno",
  //   component: Returno,
  //   meta: { authorize: [6] }
  // },
  // {
  //   path: "/asignacion",
  //   name: "Asignacion",
  //   component: Asignacion,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/apelacion-detalles",
  //   name: "Detalles",
  //   component: Detalles,
  // },
  // {
  //   path: "/cuenta-detalles",
  //   name: "CuentaDetalles",
  //   component: CuentaDetalles,
  //   meta: { authorize: [1, 2, 3, 4, 5] }
  // },
  // {
  //   path: "/cuenta-cancelar",
  //   name: "CuentaCancelar",
  //   component: CuentaCancelar,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/cuenta-sin-materia",
  //   name: "CuentaSinMateria",
  //   component: CuentaSinMateria,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/excusar",
  //   name: "CuentaExcusar",
  //   component: CuentaExcusar,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/toca-excusar",
  //   name: "ExcusarToca",
  //   component: ExcusarToca,
  //   meta: { authorize: [1, 2, 6] }
  // },
  // {
  //   path: "/amparos",
  //   name: "RegistrarAmparo",
  //   component: RegistrarAmparo,
  //   meta: { authorize: [1, 2, 3, 4, 5] }
  // },
  // {
  //   path: "/colegiadas",
  //   name: "Colegiada",
  //   component: Colegiada,
  //   meta: { authorize: [1, 2, 3] }
  // },
  // {
  //   path: "/pendientes/firma",
  //   name: "PendientesFirma",
  //   component: PendientesFirma,
  //   meta: { authorize: [1, 2, 3, 6] }
  // },
  // {
  //   path: "/comunicados/list",
  //   name: "ComunicadosList",
  //   component: ComunicadosList,
  //   meta: { authorize: [1, 2, 6] }
  // },
  {
    path: "/tocas/list",
    name: "TocasList",
    component: TocasList,
    // meta: { authorize: [1, 2, 5] }
    meta: { authorize: ['superadmin', 'admin', 'ciudadano'] }

  },
  {
    path: "/tocas/show",
    name: "TocasShow",
    component: TocasShow,
    // meta: { authorize: [1, 2, 6] }
  },
  {
    path: "/tocas/firma",
    name: "TocasFirma",
    component: TocasFirma,
    // meta: { authorize: [1, 2, 6] }
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});

async function fetchBackendUser(token) {
  try {
    const response = await axios.get(process.env.VUE_APP_BASE_URL + 'me', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch {
    return null;
  }
}

router.beforeEach(async(to, from, next) => {
  console.log(to)
  const { authorize } = to.meta;
  const user = JSON.parse(localStorage.getItem("user"));
  const token = localStorage.getItem('token') || '';

  const currentOrden = JSON.parse(localStorage.getItem("currentOrden"));
  if (authorize) {
    console.log("se necesita autorizacion pero no hay token")
    //si si tiene restricciones la ruta
    if (!user || !token) {
      //y no esta logeado entonces a logear
      return next({
        path: "/"
      });
    }
    //aqui ya esta el token
    const backendUser = await fetchBackendUser(token);
    console.log("mi backend", backendUser)

    if (!backendUser) {
      // Token inválido o expirado
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('currentToca');
      store.commit('setUser', null);
      return next({ path: "/login" });
    }

    // Sincronizar rol y usuario con backend
    if (JSON.stringify(user) !== JSON.stringify(backendUser)) {
      console.log("no son iguales")
      console.log("baclenUser",backendUser)
      console.log("user",user)

      localStorage.setItem('user', JSON.stringify(backendUser));
      store.commit('setUser', backendUser);
    } else if (!store.state.user) {
      console.log("SON iguales")
      store.commit('setUser', user);
    }

    //checar si la routa esta restringida por algun role_id y  NO coincide el role_id del user logeado
    if (authorize.length && !authorize.includes(user.rolename)) {
      return next({ path: "/tocas/list" });
    }
  }
  if ((to.path === "/" || to.path === "/login") && user) {
    return next({ path: "/tocas/list" });
  }
  next();
});

export default router;
